import React, { useContext, useEffect, useState } from "react";
import localization from "../../../assets/localization/localization";
import Layout from "../../../components/sales/layout/layout";
import DivLayout from "../../../components/sales/divLayout/divLayout";
import ModalPop from "components/sales/modal/modal";
import ConstantInput from "../../../components/sales/Input/constantInput/constantInput";
import { Button } from "react-bootstrap";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import CustomModal from "../../valetServices/modal";

const RequestView = ({
  viewRequest,
  showData = [],
  match,
  walletFinanceRequest,
  walletfinancerequestDetails = [],
  history,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [inputList, setInputList] = useState({
    amount: "",
    remark: "",
    type: "",
    wallet_type: "",
    wallet_id: "",
  });

  const [count, setCount] = useState(0);


  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const requestData = {
        id: match?.params?.id,
        amount: inputList.amount,
        remark: inputList.remark,
        type: inputList.type,
        wallet_type: "internal",
        wallet_id: match?.params?.wallet_id,
      };

      await walletFinanceRequest(requestData);
      setCount(count + 1);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error in walletFinanceRequest:", error);
    }
  };

  useEffect(() => {
    if(match.params.id !== undefined) { console.log(match.params.id);
    (async () => {
        setIsLoading(true)
        await viewRequest(match?.params?.id);
        setIsLoading(false)
    })()
}
}, []);

// {console.log(showData)}
  return (
    <>
      <Layout title={localization.wallet} isLoading={isLoading} isGoback={true}>
        <div className="panel-card card-details" width="100%">
          {walletfinancerequestDetails !== null &&
            walletfinancerequestDetails?.response?.status !== 200 && (
              <CustomModal
                msg={walletfinancerequestDetails?.response?.message}
                click={count}
              />
            )}
          {walletfinancerequestDetails !== null &&
            walletfinancerequestDetails?.response?.status === 200 && (
              <CustomModal
                msg={walletfinancerequestDetails?.response?.message}
                isPageLoad={true}
                click={count}
                url={`${baseUrl}/request-transaction-details/${match?.params?.id}`}
                history={history}
              />
            )}
          <div className="panel-heading">{localization.RequestDetails}</div>
          <div className="panel-body">
            <div className="details-listing detail_alignment">
            
              <div className="col-sm-6">
                <p>
                  {"Total Amount"}: {showData.amount}
                </p>
              </div>
              <div className="col-sm-6">
                <p>
                  {"Left Amount"}: {showData.left_redeem_amount}
                </p>
              </div>
                <>
                  <div className="col-sm-6">
                    <ConstantInput
                      label={localization.amount}
                      value={inputList.amount}
                      type="number"
                      isStarRequired={true}
                      handleChange={(val) =>
                        setInputList({ ...inputList, amount: val })
                      }
                      required={true}
                    />
                  </div>
                  <div className="col-sm-6">
                    <ConstantInput
                      label={localization.remark}
                      value={inputList.remark}
                      type="text"
                      isStarRequired={true}
                      handleChange={(val) =>
                        setInputList({ ...inputList, remark: val })
                      }
                      required={true}
                    />
                  </div>
                  <div className="col-md-6 mb-5">
                    <Button onClick={handleSubmit}>
                      {localization.submitDtl}
                    </Button>
                  </div>
                </>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default RequestView;
